export default function Reset() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9162 20C5.73011 19.729 3.91891 18.776 2.4826 17.1409C1.04628 15.5059 0.328125 13.5863 0.328125 11.3821C0.328125 10.1897 0.562994 9.04697 1.03273 7.95393C1.50247 6.86089 2.17094 5.90786 3.03815 5.09485L4.58287 6.63957C3.89633 7.25384 3.37691 7.96748 3.0246 8.78049C2.6723 9.5935 2.49615 10.4607 2.49615 11.3821C2.49615 12.972 3.00202 14.3767 4.01376 15.5962C5.02551 16.8157 6.32632 17.561 7.9162 17.832V20ZM10.0842 20V17.832C11.656 17.5429 12.9523 16.7931 13.9731 15.5827C14.9939 14.3722 15.5043 12.972 15.5043 11.3821C15.5043 9.57543 14.8719 8.03975 13.6073 6.77507C12.3426 5.51039 10.8069 4.87805 9.00021 4.87805H8.91891L10.1113 6.07046L8.59371 7.58808L4.79967 3.79404L8.59371 0L10.1113 1.51762L8.91891 2.71003H9.00021C11.4212 2.71003 13.4718 3.55014 15.152 5.23035C16.8322 6.91057 17.6723 8.96116 17.6723 11.3821C17.6723 13.5682 16.9541 15.4788 15.5178 17.1138C14.0815 18.7489 12.2703 19.7109 10.0842 20Z"
        className="fill-main-black"
      />
    </svg>
  )
}
